module.exports = __webpack_public_path__ + "img/1638746-88-9.b64b2004.png";